import BNStore from "../img/Bn store.png";
import epm from "../img/employeeMmanagementSystem.png";
import portfolio from "../img/portfolio.png";
import hms from "../img/hms.png";
import nanofinance from "../img/nanofinance.png";
import BnEstate from "../img/BnEstate.png";
import shreeDharapaniSamaj from "../img/shreedharapani.png";
import highfiveadventure from "../img/highfiveadventure.png";
import infinityAdventureNepal from "../img/infinityAdventureNepal.png";
import epeakExpedition from "../img/epeak-expedition.png";
import kingfisherRealEstate from "../img/kingfisherRealEstate.png";
import flyeastnepal from "../img/flyeast.png";
import biplapblog from "../img/biplap-blog.png";
const projects = [
  {
    slug:"biplap-blog",
    title: "Biplap Neupane BLog",
    image: biplapblog,
    alt: "Biplap Blog is a personal blog website created by Biplap Neupane. It provides a platform for sharing knowledge, insights, and experiences in technology and lifestyle.",
    url: "https://blog.biplapneupane.com.np/",
    description: "Biplap Blog is a personal blog created by Biplap Neupane, offering a space for sharing valuable knowledge, insights, and experiences in various areas, particularly focusing on technology and lifestyle. The website serves as a platform where readers can find articles related to tech trends, gadgets, software, and other related subjects, along with lifestyle topics that resonate with modern-day living.Through Biplap Blog, readers can expect well-researched content, tips, and tutorials that can help them navigate the ever-evolving digital world, along with thought-provoking lifestyle advice. The blog aims to bridge the gap between tech enthusiasts and everyday individuals, making complex topics accessible to all while providing useful insights for a better lifestyle. Whether you're a tech lover, looking for recommendations on the latest gadgets, or simply interested in personal growth and lifestyle, Biplap Blog is your go-to resource for all things tech and beyond!"
  },
  {
    slug:"dharapani-neupane-samaj-kathmandu",
    title: "Dharapani Neupane Samaj Kathmandu",
    image: shreeDharapaniSamaj,
    alt: "Dharapani Neupane Samaj Kathmandu Project made with Next.js and Tailwind CSS by Biplap Neupane",
    url: "https://dharapani-neupane-samaj.biplapneupane.com.np/",
    description: "Dharapani Neupane Samaj Kathmandu is a nonprofit organization dedicated to fostering unity, preserving culture, and supporting the well-being of the Neupane community from Dharapani. This website, designed and developed as a solo project by me using Next.js and Tailwind CSS, serves as an informative and user-friendly platform for community members to stay updated on events, notices, social initiatives, and organizational news. It aims to strengthen connections within the community by providing easy access to important resources and opportunities to engage and contribute."

  },
  {
    slug: "highfiveadventure",
    title: "HighFiveAdventure",
    image: highfiveadventure, 
    alt: "HighFiveAdventure Project made with Next.js and Tailwind CSS by Biplap Neupane",
    url: "https://highfiveadventure.com/",
    description: "HighFiveAdventure is a professionally developed website created as part of a team project in a corporate environment. Designed for a trekking and adventure travel company, the platform highlights various tours, itineraries, and booking options, allowing users to explore the natural beauty of Nepal through guided experiences. Built using Next.js and Tailwind CSS, the site delivers a fast, responsive, and user-friendly experience tailored to both local and international adventure seekers."

  },{
    slug:"flyeastnepal",
    title: "FlyEastNepal",
    image: flyeastnepal,
    alt: "FlyEastNepal Project made with Next.js and Tailwind CSS by Biplap Neupane",
    url: "https://flyeastnepal.com/",
    description: "FlyEastNepal is a professionally developed website created as part of a team project in a corporate environment. Designed for a trekking and adventure travel company, the platform highlights various tours, itineraries, and booking options, allowing users to explore the natural beauty of Nepal through guided experiences. Built using Next.js and Tailwind CSS, the site delivers a fast, responsive, and user-friendly experience tailored to both local and international adventure seekers."
  },
  {
    slug:"infinity-adventure-nepal",
    title: "Infinity Adventure Nepal",
    image: infinityAdventureNepal,
    alt: "Infinity Adventure Nepal Project made with Next.js and Tailwind CSS by Biplap Neupane",
    url: "https://infinityadventurenepal.com/",
    description: "Infinity Adventure Nepal is a modern, team-built web platform developed in a professional setting for a trekking and adventure travel company. It features comprehensive tour details, itineraries, and booking capabilities, enabling users to plan and experience guided adventures across Nepal. Developed using Next.js and Tailwind CSS, the site delivers a fast, responsive, and engaging user interface tailored to adventure seekers worldwide."

  },
  {
    slug:"epeak-expedition",
    title:"Epeak Expedition",
    image:epeakExpedition,
    alt:"Epeak Expedition Project made with Next.js and Tailwind CSS by Biplap Neupane",
    url:"https://epeakexpedition.com/home",
    description: "Epeak Expedition is a professionally developed website created for a trekking and adventure travel company. Designed with Next.js and Tailwind CSS, the platform highlights a variety of tour packages, detailed itineraries, and booking options to help travelers experience the breathtaking landscapes of Nepal through expertly guided adventures."

  },
  {
    slug:"kingfisher-real-estate",
    title: "Kingfisher Real Estate",
    image: kingfisherRealEstate,
    alt: "Kingfisher Real Estate Project made with React.js and Tailwind CSS by Biplap Neupane",
    url: "https://kingfisherrealestate-live.vercel.app/",
    description: "Kingfisher Real Estate is a fully functional real estate web application developed as a solo project by me for a client based in Dubai. This professional-grade platform includes a custom-designed frontend, backend, and admin dashboard to manage property listings and user data efficiently. Built using React.js and Tailwind CSS, the application delivers a clean, responsive, and user-friendly interface for both property managers and clients, ensuring smooth navigation and streamlined property management."
  },
  {
    slug:"bn-store",
    title: "BN Store",
    image: BNStore,
    alt: "BN Store Project made with React.js and Tailwind CSS by Biplap Neupane",
    url: "https://github.com/biplap12/ecommerce_grocery_store.git",
    description: "BN Store is an e-commerce platform that allows users to purchase groceries and other household items online. The platform is built using React.js and Tailwind CSS, and is designed to be user-friendly and easy to navigate.",
  },
  {
    slug:"employee-management-system",
    title: "Employee Management System",
    image: epm,
    alt: "Employee Management System Project made with Python Django and Bootstrap html and CSS by Biplap Neupane",
    url: "https://github.com/biplap12/Attendance-Management-using-Face-Recognition.git",
    description: "Employee Management System is a web application that allows users to manage their employees and their attendance. The application is built using React.js and Tailwind CSS, and is designed to be user-friendly and easy to navigate.",
  },
  {
    slug:"portfolio",
    title: "Portfolio",
    image: portfolio,
    alt: "Portfolio Project made with React.js and Tailwind CSS by Biplap Neupane",
    url: "https://biplap-neupane.vercel.app/",
    description: "Portfolio is a website that provides information about the Biplap Neupane. The website is built using React.js and Tailwind CSS, and is designed to be user-friendly and easy to navigate.",
  },
  {
    slug:"hospital-management-system",
    title: "Hospital Management System",
    image: hms,
    alt: "Hospital Management System Project made with React.js and Tailwind CSS by Biplap Neupane",
    url: "https://hms-frontendbpbiplap.vercel.app/",
    description: "Hospital Management System is a web application that allows users to manage their hospital and their patients. The application is built using React.js and Tailwind CSS, and is designed to be user-friendly and easy to navigate.",
  },
  { 
    slug:"nano-finance",
    title: "NanoFinance",
    image: nanofinance,
    alt: "Nanofinance Project made with React.js and Tailwind CSS by Biplap Neupane",
    url: "https://github.com/biplap12/NanoFinance.git",
    description: "NanoFinance is a web application that allows users to manage their NanoFinance and their patients. The application is built using React.js and Tailwind CSS, and is designed to be user-friendly and easy to navigate.",
  },
  {
    slug:"bn-estate",
    title: "BnEstate",
    image: BnEstate,
    alt: "BnEstate Project made with React.js and Tailwind CSS by Biplap Neupane",
    url: "https://bn-estate.vercel.app/",
    description: "BnEstate is a web application that allows users to manage their BnEstate and their patients. The application is built using React.js and Tailwind CSS, and is designed to be user-friendly and easy to navigate.",
  },
  
];

export default projects;
